export type ErrorType = {
  type: string
}

export const contentErrors: ErrorType[] = [
  { type: 'CLAERR0005' },
  { type: 'CLAERR0006' },
  { type: 'CLAERR0007' },
  { type: 'CLAERR0013' },
  { type: 'CLAERRCOV2200109' },
  { type: 'CLAERRCOV2200309' },
  { type: 'CLAERRCOV20007' },
  { type: 'CLAERRCOV2200310' },
  { type: 'CLAERRCOV2200310' },
  { type: 'CLAERRCOV2200313' },
  { type: 'CLAERRCOV20010' },
  { type: 'CLAERRCOV2100032' },
  { type: 'CLAERRCOV2100278' },
  { type: 'CLAERRCOV2100171' },
]
